module.exports = __webpack_public_path__ + "img/logo.54d63e9e.png";